export class ReportePagosEfectuados {

    public idCompania: string;
    public idViaje: string;
    public idVisita: string;
    public tipoPago: string;
    public referencia1: string;
    public referencia2: string;
    public numeroDocumento: string;
    public numeroOrden: string;
    public monto: number;
    public observaciones: string;
    public montoSugerido: number;
    public condicionPago: string;
    public idPunto: string;
    public nombrePunto: string;
    public fechaFinalizacion: Date;

    public cantidad: number;
    public idUsuario: string;
    public nombreUsuario: string;

    public cantidadConfirmada: number;
    public cantidadDevuelta: number;
    public codigo: string;
    public codigoDescripcion: string;
    public motivoDescripcion: string;
    public numeroDocumento_devWMS: string;
}